export const SIDEBAR_WIDTH = '250px';
